/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  AnalyticeWidgetService,
  IAnalyticsWidgetMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
} from './components';

export type ProductAnalyticsAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IAnalyticsWidgetMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new AnalyticeWidgetService(),
    new StaticPageContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<ProductAnalyticsAgent>({
    plugins: getPlugins(),
  });
};
